var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-graph',{attrs:{"traces":_vm.traces,"title":_vm.selectedTrialName,"graph-type":_vm.graphType}})}
var staticRenderFns = []

export { render, staticRenderFns }